import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
const PopupModal = ({ isOpen, onClose, onPost, isSubmitting, formData, setFormData, handleCaptcha }) => {    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-lg opacity-100">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 p-8 relative">
                <button
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-700"
                    onClick={onClose}
                    aria-label="Close"
                    type="button"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <h2 className="mb-6 text-2xl font-bold text-blue-700 text-center">Quick Contact</h2>
                <div className="modal-body">
                    <form onSubmit={onPost} className="space-y-5">
                        <div>
                            <input
                                type="text"
                                name="name"
                                placeholder="Name"
                                value={formData.name}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:outline-none"
                                required
                            />
                        </div>
                        <div>
                            <input
                                type="tel"
                                name="mobile"
                                placeholder="Mobile Number"
                                value={formData.mobile}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:outline-none"
                                required
                            />
                        </div>
                        <div>
                            <input
                                type="text"
                                name="company"
                                placeholder="Company"
                                value={formData.company}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:outline-none"
                            />
                        </div>
                        <div>
                            <input
                                type="number"
                                name="numberoflr"
                                placeholder="Number of LR per Month"
                                value={formData.numberoflr}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:outline-none"
                            />
                        </div>
                        <div>
                            <input
                                type="number"
                                name="numberofbranch"
                                placeholder="Number of Branch"
                                value={formData.numberofbranch}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:outline-none"
                            />
                        </div>
                        <div>
                            <textarea
                                name="message"
                                placeholder="Message"
                                value={formData.message}
                                onChange={handleChange}
                                rows={3}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:outline-none"
                                required
                            ></textarea>
                        </div>
                        <ReCAPTCHA sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY} onChange={handleCaptcha} />
                        <button
                            type="submit"
                            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg transition-all shadow"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Sending..." : "Send"}
                        </button>                        
                    </form>
                </div>
            </div>
        </div>
    );
}

export default PopupModal;